import { Component, Input } from '@angular/core';

@Component({
    selector: 'ms-baseball-scoreboard-base-runner',
    templateUrl: 'baseball-scoreboard-base-runner.component.html',
    standalone: false,
})
export class BaseballScoreboardBaseRunnerComponent {
    @Input() base: string;
}
